import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app-config';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ILanguage } from 'src/app/core/models/i-language';
import { RestService } from 'src/app/shared/services/rest-service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  static readonly ENTITY_IDENTIFIER: string = 'language';
  contentResultLimit: number;

  private readonly BASE_LANGUAGE_ROUTE = `api/${LanguageService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_LANGUAGE_ROUTE, ...args);

  constructor(private restService: RestService) {}

  // TODO IMPROVEMENT: Could be just a wrapper of getFilterd$ with no filters.
  getAll$(): Observable<ILanguage[]> {
    return this.restService.get$<ILanguage[]>(this.BUILD_HTTP_ROUTE());
  }
}
